import * as Sentry from '@sentry/react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AddToPhotos, Delete } from '@mui/icons-material';
import { ArrowBackIos, ArrowForwardIos, Close } from '@mui/icons-material';
import { Modal , Button, IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import COLOR from 'utils/constants/color';
import {Snackbar, Alert, TextField, Typography } from '@mui/material';

import moment from "moment-timezone";
import queryString from 'query-string';
import styled from "styled-components";
import { Row , Col, Progress} from "antd";
import { findIndex , get , find} from "lodash";
import { graphic_data } from "utils/constants/graphic_org";
import { handleCreateSubmission, handleUpdateSubmission  } from 'store/submissions/thunks';
import * as SubmissionsActions from 'store/submissions/actions';
import { useAssignmentSessionTracking } from 'hooks/useAssignmentSessionTracking';
import { useAssignmentSessionReplay } from 'hooks/useAssignmentSessionReplay';
import { handleGradeToSchoology } from 'store/schoology/thunks';
import { handleUpdateCanvasGrade , handleCreateCanvaSubmissions } from 'store/canvas/thunks';
import { isBeforTime } from "utils/methods/math";
import { ref as fireRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from 'firebaseConfig';
import { useAllBook } from "store/books/selectors";
import { useClassSubmissions } from "store/submissions/selectors";
import { useCollectionAutoSubmission } from "utils/methods/firebaseAutoSubmission";
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { useCurrentClass, useCurrentClassTeacher } from "store/classes/selectors";
import { useCurrentUser } from "store/users/selectors";
import { useOrgTimezone } from "store/organizations/selectors";
import { useServertime } from "store/servertime/selectors";
import { useSocket } from 'store/chat/selectors';
import { useTimmerRunning } from "store/timmer/selectors";
import { v4 } from 'uuid';
import './GraphicAssignmentTake.css';
import Loading from "./Loading";
import { useFocusOutside } from "./OnClickOutside";
import { handleUpdateGradeToGoogleClassRoom } from "store/googleClassRoom/thunks"
import { useAlert } from './UI/alertSakeBar/alertProvider';
import { imageFetchFromPodcast, isVideo } from 'utils/lib/ebookHelper';
import { useResources } from 'store/resources/selectors';
import { IMAGE_FILE_TYPE } from 'utils/constants/enum';
import useBadWords from './hooks/words/badWords';
import SentryWrap from 'components/Sentry';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
let timeout;
const StyledTextField = muiStyled(TextField)(({ theme, hasBorder = true }) => ({
  '& .MuiInput-underline:before': {
    borderBottomColor: hasBorder ? 'black' : 'transparent',
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottomColor: hasBorder ? 'black' : 'transparent',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: hasBorder ? 'black' : 'transparent',
  },
  '& .MuiInputBase-root': {
    padding: '2px',
    width: '100%',
  },
  '& .MuiInputBase-input': {
    fontSize: 16,
    '@media (max-width: 600px)': {
      fontSize: 10,
    },
    '@media (min-width: 600px) and (max-width: 960px)': {
      fontSize: 15,
    },
    '@media (min-width: 960px)': {
      fontSize: 16,
    },
  },
}));

function debounce(func, delay) {
    return function (...args) {
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}
const PlanWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
  padding: 20px;
`;

const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  position: relative;
  justify-content: center;
  background-color: white;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0px 20px;
  padding-left: 40px;
  padding-right: 105px;

  @media only screen and (max-width: 1400px) {
    overflow:auto;
    overflow-x: hidden;
  }
 @media only screen and (max-width: 991px) {
  display:unset;
  max-height: 96%;
  margin-bottom: 5%;
  width:85%;
   padding: 20px;
   padding-bottom:45px;
 }
  @media only screen and (max-width: 500px) {
    width: 95%;
  }
`;

const CloseBtn = styled.div`
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const Container = styled.div`
  display: flex;
`;

const PrintWrapper = styled.div`
  display: flex;
`;

const Images = styled.img`
  background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: cover;
  height: auto;
  width:100%;

    @media only screen and (max-width: 1500px) {
        height:auto;
        width:100%;
    }
    // @media only screen and (max-width: 992px) {
    //   margin-top:50px;
    // }
    //   @media only screen and (max-width: 360px) {
    //     margin-top: 42px!important;
    // }
`;
const UploadedImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    cursor: pointer;
    padding:10px;
`;
const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  height: 40px;
  left: ${(p) => `${p.left}px`};
  outline: none;
  position: absolute;
  right: ${(p) => `${p.right}px`};
  top: 50%;
  transition: all 300ms ease;
  width: 40px;
  z-index: 1;
`;
const AnswerWindowWrapper = styled.div`
   position: relative;
   width: 100%;
`;
const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    width:96%;

    @media only screen and (max-width: 650px) {
      margin-top: 20px;
      border: none;
    }
`;

const ImageContainer = styled.div`
    height: auto;
    flex: 1;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;
const ImageModal = styled.div`
    left: 50%;
    max-width: 544px;
    padding: 0px 24px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
`;
const Image = styled.img`
    border: 1px solid ${COLOR.black800};
    width: 100%;
    height: auto;
`;
function ImageUploader({ src, onChange, positions,setLoaderImg,loaderImg,index,setLoadingIndex,loaderS }) {
    const [pagePoster, setpagePoster] = useState(src)
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)
    const [modalOpen, setModalState] = useState(false)
    useEffect(() => {
        setpagePoster(src)
    }, [src])
    const handleChange = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        uploadToStorage(file)
        reader.onloadend = function (e) {
            let v = reader.result;
            setpagePoster(v)
        };
    };
    const handleDelete = () => {
        setpagePoster(null);
        onChange(null,index);  // Call this to reflect the change outside
    };
    const uploadToStorage = async (file) => {
        if (file) {
            const location = '/assignments/graphic_organizer';
            const id = `${moment().format('YYYY-MM-DD HH:mm:ss')}-${file.name}`;
            const fileRef = fireRef(storage, `${location}/${id}`);

            try {
                setLoaderImg(true)
                setLoadingIndex(index)
                const uploadTask = uploadBytesResumable(fileRef, file);
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const per = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        setLoadingMap(per);
                        setLoader(true);
                    },
                    (error) => {
                        console.error("Upload error:", error);
                        setLoader(false);
                        setLoadingMap(0);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            setLoader(false);
                            setLoadingMap(0);
                            onChange(downloadURL);
                        });
                    }
                );
            } catch (error) {
                Sentry.captureException(`213 Error uploading file: ${error}`);
                console.error("Upload error:", error);
                setLoader(false);
                setLoadingMap(0);
            }
        } else {
            console.log("No file to upload.");
        }
    };
    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : { minHeight:"50px"};
    return (<>
        <Modal
            open={modalOpen}
            onClose={() => setModalState(false)}
            style={{ height: '100%', width: '100%' , zIndex:9999999999999}}
        >
            <ImageModal>
                <Image src={pagePoster} alt='' />
            </ImageModal>
        </Modal>
        <ImageContainer className={`${positions.class_name}`} onContextMenu={(e) => { }} style={{
            position: 'absolute',
            width: `calc(${positions.width} * 100%)`,
            height: positions.height ? `calc(${positions.height} * 100%)` : 'auto',
            left: `calc(${positions.left} * 100%)`,
            top: `calc(${positions.top} * 100%)`,
            ...max_height,
            ...min_height,
            justifyContent: "center",
            alignItems: 'center',
            display: "flex",
        }}>
            {loaderImg && loaderS && (
                <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                }}
                >
                <Loading size={40} />
                </div>
            )}
            {pagePoster ? <>
                {/* {(loaderImg &&loaderS) && (
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10000 }}>
          <Loading size={14} white />
        </div>
      )} */}
                <UploadedImage onClick={() => setModalState(true)} src={pagePoster} />
                <IconButton color="secondary" style={{ position: "absolute", right: 6, top: -14 , zIndex:9999 , padding:0 }} onClick={handleDelete}
                ><Delete /></IconButton>
            </> :
                <FileUploader
                    handleChange={handleChange}
                    name="file"
                    types={IMAGE_FILE_TYPE}
                    disabled={loaderImg}
                >
                    <FileUploadArea>
                        {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                        <Row className="box box-1" style={{ display: "flex", gap: 4 }}>
                            <Column >
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column>
                                <Text>
                                    Upload here
                                </Text>
                            </Column>
                        </Row>
                        <Row>
                            <Text style={{ fontSize: 8 }}>
                                {IMAGE_FILE_TYPE.join(",")}
                            </Text>
                        </Row>

                    </FileUploadArea>
                </FileUploader>}
        </ImageContainer>
    </>)
}

const IngresoInput = [
    'ingreso-input1',
    'ingreso-input2',
    'ingreso-input3',
    'ingreso-input4',
    'ingreso-input5',
    'ingreso-input6',
    'ingreso-input7',
    'ingreso-input8',
    'ingreso-input9',
    'ingreso-input10',
    'ingreso-input11',
    'ingreso-input12',
    'ingreso-input13',
    'ingreso-input14',
    'ingreso-input15',
    'ingreso-input16',
    'ingreso-input17',
    'ingreso-input18',
    'ingreso-input19',
    'ingreso-input20',
    'ingreso-input21',
    'ingreso-input22',
    'ingreso-input23',
    'ingreso-input24',
    'ingreso-input25',
    'ingreso-input26',
    'ingreso-input27',
    'ingreso-input28',
    'ingreso-input29',
    'ingreso-input30',
    'ingreso-input31',
    'ingreso-input32',
    'ingreso-input33',
    'ingreso-input34',
    'ingreso-input35',
    'ingreso-input36',
    'ingreso-input37',
    'ingreso-input38',
    'ingreso-input39',
    'ingreso-input40',
    'ingreso-input41',
    'ingreso-input42',
    'ingreso-input43',
    'ingreso-input44',
    'ingreso-input45',
    'ingreso-input46',
    'ingreso-input47',
    'ingreso-input48'
  ];
  
  const backendClsNme = (positions) => {
    if (IngresoInput.includes(positions?.class_name)) {
      return {};
    } else {
      return { overflow: "auto" };
    }
  };


const InputArea = ({ positions, onChange, value, setLoaderImg, loaderImg, index, setLoadingIndex, loaderS, isLabel = false }) => {
    if (positions.input_type === "image") {
        return (<ImageUploader src={value} onChange={onChange} positions={positions} setLoaderImg={setLoaderImg} loaderImg={loaderImg} index={index} setLoadingIndex={setLoadingIndex} loaderS={loaderS}/>)
    }
    const hideOverflow = backendClsNme(positions)
    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : {};
    const height_value = positions.height ? { height: `calc(${positions.height} * 100%)` } : {};
    const width_value = positions.width ? { width: `calc(${positions.width} * 100%)` } : {};
    const top_value = positions.top ? { top: `calc(${positions.top} * 100%)` } : {};
    const paddingTop = positions.paddingTop ? { paddingTop: `calc(${positions.paddingTop} * 100%)` } : {};
    const left_value = positions.left ? { left: `calc(${positions.left} * 100%)` } : {};
    const hasBorder = typeof positions.bottom_border === "boolean" ? positions.bottom_border : true;

    // if (isLabel) {
    //     return value;
    // }

    return (
        <StyledTextField
            className={`${positions.class_name} custom-scrollbar`}
            multiline={positions.text_length === "multi_line"}
            style={{
                position: 'absolute',
                ...hideOverflow,
                alignItems: 'center',
                ...max_height,
                ...min_height,
                ...height_value,
                ...width_value,
                ...top_value,
                ...left_value,
                ...paddingTop
            }}
            placeholder={positions.placeholder || ''}
            onChange={e => onChange(e.target.value)}
            value={value}
            label=""
            hasBorder={hasBorder}
            InputProps={{
                readOnly: isLabel,               // 👈 disables editing and cursor blinking
              }}
        />
    );
};

const LabelPositionArea = ({ positions, onChange, value, setLoaderImg, loaderImg, index, setLoadingIndex, loaderS, isLabel = false }) => {
    if (positions.input_type === "image") {
        return (<ImageUploader src={value} onChange={onChange} positions={positions} setLoaderImg={setLoaderImg} loaderImg={loaderImg} index={index} setLoadingIndex={setLoadingIndex} loaderS={loaderS}/>)
    }
    const hideOverflow = backendClsNme(positions)
    const max_height = positions.max_height ? { maxHeight: positions.max_height } : {};
    const min_height = positions.min_height ? { minHeight: positions.min_height } : {};
    const height_value = positions.height ? { height: `calc(${positions.height} * 100%)` } : {};
    const width_value = positions.width ? { width: `calc(${positions.width} * 100%)` } : {};
    const top_value = positions.top ? { top: `calc(${positions.top} * 100%)` } : {};
    const paddingTop = positions.paddingTop ? { paddingTop: `calc(${positions.paddingTop} * 100%)` } : {};
    const left_value = positions.left ? { left: `calc(${positions.left} * 100%)` } : {};
    const hasBorder = typeof positions.bottom_border === "boolean" ? positions.bottom_border : true;

    // if (isLabel) {
    //     return value;
    // }

    return (
        <div
            className={`${positions.class_name} custom-scrollbar`}
            // multiline={positions.text_length === "multi_line"}
            style={{
                position: 'absolute',
                ...hideOverflow,
                alignItems: 'center',
                ...max_height,
                ...min_height,
                ...height_value,
                ...width_value,
                ...top_value,
                ...left_value,
                ...paddingTop,
                backgroundColor: positions.background_color || '',
                // color: 'red',
                fontSize: 16,
                fontWeight: 600,
                zIndex: 1000,
            }}
            // placeholder={positions.placeholder || ''}
            // onChange={e => onChange(e.target.value)}
            // value={value}
            // label=""
            //hasBorder={hasBorder}
            //InputProps={{
            //    readOnly: isLabel,               // 👈 disables editing and cursor blinking
            //  }}
        >
            {value}
        </div>
    );
};
  const AnswerWindow = ({ src ,input_position , onSunmit , onFinishLaterSave , isLoading , submission ,timeInt,setFinishLaterAlert,timmer , values, setValues, pastSubmission, updateOnInterval, isTime, label_position }) => {
    const { ref, isFocused } = useFocusOutside();
    const [inputs] = useState(input_position||[]);
    const [labelPositions] = useState(label_position||[]);
    // const [values,setValues] = useState([])
    const [loader,setLoader] = useState('submit');
    const [loaderImg,setLoaderImg] = useState(false);
    const [loadingIndex,setLoadingIndex] = useState(-1);
    const showAlert = useAlert();
    const { checkBadWords } = useBadWords('assignment');
    const onValueChange = (v, index, type) => {
        let vals = [...values];
        if (v === undefined || v === null || v === '') {
            vals[index]=null
        } else {
            vals[index] = { answer: v, type };
        }
        setValues(vals);
        setLoaderImg(false);
        setLoadingIndex(-1);
        updateOnInterval(vals)
    };
    useEffect(()=>{
        if(values.length==0){
            if(submission&&Array.isArray(submission.answers) && submission.answers.length>0){
                setValues(submission.answers)
            }
            else if(pastSubmission&&Array.isArray(pastSubmission.answers) && pastSubmission.answers.length>0){
                setValues(pastSubmission.answers)
            }
        }
       
    }, [submission])

    const checkBadWordsInAnswer = () => {
        try{
            const answerText = values?.length > 0 ? values.map(v => v?.answer).join(' ') : '';
            const { isFound } = checkBadWords(answerText, null,true);
            if (isFound) {
                return true;
            }
            return false;
        }catch(error){
            console.log(error, 'error in checkBadWordsInAnswer');   
            return false;
        }
    }
    
    const onSubmission = () =>{
        const isBadWords = checkBadWordsInAnswer();
        if(isBadWords){
            return;
        }
        onSunmit(values,true) 
        setLoader('submit')
    }
    const onFinishLater = () =>{
        const isBadWords = checkBadWordsInAnswer();
        if(isBadWords){
            return;
        }
        if (isLoading) return;
        if (timmer > 0) {
            setFinishLaterAlert({ open: true, message: 'This functionality is blocked for time-based activities.' })
        } else {
        if (onFinishLaterSave) onFinishLaterSave(values);
        else onSunmit(values,false);
        setLoader('finish_later')
    }
    }
    const submit_disbale = inputs.length !== values.filter(k=>k).length  || isLoading
      return (
         <>
          <AnswerWindowWrapper tabIndex={0} ref={ref} className={`manageInputCstm ${isFocused ? "graphicNote-oragnizer-navigation" : ""}`}>
             {/* <Images src={src} /> */}
            {isTime && (
            <div className="graphicTimer" style={{ position: "absolute", top: 40, right: "-98px",width:"92px",textAlign:"center", backgroundColor: COLOR.indigo600,zIndex:99,borderRadius:"5px",padding:"7.5px 10px 7.5px 10px",color:"#fff"  }} 
            >
              {timeInt}
              </div>
            )}
            {labelPositions.map((label, index) => {
                return(
                    <LabelPositionArea key={index} positions={label} value={label?.value || ''}
                     onChange={v => onValueChange(v, index, label.input_type)} 
                     setLoaderImg={setLoaderImg} 
                     loaderImg={loaderImg} 
                     index={index} setLoadingIndex={setLoadingIndex} loaderS={loadingIndex==index} isLabel={true}/>
                )
            })}
            <Images src={src} />
            {inputs.map((input, index) => (
                <InputArea key={index} positions={input} value={values[index]?.answer} onChange={v => onValueChange(v, index, input.input_type)} setLoaderImg={setLoaderImg} loaderImg={loaderImg} index={index} setLoadingIndex={setLoadingIndex} loaderS={loadingIndex==index}/>
            ))}
          </AnswerWindowWrapper>
          <div className='buttonFinishSub'>
            <Button
                className="buttonFinishBtn"
                startIcon={loader === "finish_later" && isLoading ? <Loading size={12} white /> : null}
                disabled={isLoading} 
                onClick={onFinishLater}>Finish later</Button>
            <Button
                className="buttonSbmtBtn"
                style={{ opacity : submit_disbale ? 0.5 : 1 }}
                startIcon={loader === "submit" && isLoading ? <Loading size={12} white /> : null}
                disabled={submit_disbale} onClick={onSubmission}>Submit</Button>
            </div> 
        </>  
      );
  };
  

const GraphicAssignmentTake = ({
   open ,
   setOpen,
   assignment
}) => {
    const showAlert = useAlert();
    const dispatch = useDispatch();
    const backBtnRef = useRef(null);
    const forwardBtnRef = useRef(null);
    const location = useLocation();
  	const navigate = useNavigate();
    const resources = useResources()
    const currentClass  = useCurrentClass()
    const currentUser = useCurrentUser();
    const booksAllList = useAllBook()
    const servertime = useServertime()
    const timezone = useOrgTimezone()
    const currentClassTeacher = useCurrentClassTeacher();
    const {createCollectionNotification} = useCollectionNotification();
    const { createCollectionSubmission } = useCollectionAutoSubmission()
    const {socketConnection:socket , reCreateSocket } = useSocket()
    const [alertSakeBar, setAlertSakeBar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const selected_book = useMemo(() => find(booksAllList, { id: assignment.data.chapter }), [booksAllList,assignment]);

    const select_book_pages = useMemo(() => get(selected_book, "pages", []), [selected_book]);
    const pageId = useMemo(() => get(assignment, "data.assignment_page"), [assignment])

    const input_position = useMemo(() => get(assignment, "data.input_position", []) || [], [assignment])
    const label_position = useMemo(() => get(assignment, "data.label_position", []) || [], [assignment])
    const currentPageResourse = useMemo(() => get(find(graphic_data, (obj) => obj.pageId == pageId), label_position?.length > 0 ? "edit_image_src" : "src"), [assignment])
    // const currentPageResourse = useMemo(() => get(find(graphic_book_pages, (obj) => obj.pageId == pageId), "resource"), [assignment,graphic_book_pages])
    const [currentPageIndex, setCurrentPageIndex] = useState(0);

    const activePageResource = useMemo(() => {
        if(isVideo(get(assignment, "data.chapter"), resources)) {
            return imageFetchFromPodcast(assignment.data.chapter, resources);
        } else {
            return select_book_pages[currentPageIndex]?.resource;
        }
    }, [currentPageIndex, select_book_pages]);

    const submissions = useClassSubmissions()
    const currentSubmission = useMemo(()=>find(submissions, ['assignmentId', assignment?.data.id]), [assignment,submissions]) 
    const pastSubmission = useMemo(()=> currentSubmission?.pastSubmissions? currentSubmission.pastSubmissions.sort((a, b) => parseInt(b.submissions) - parseInt(a.submissions))[0]:null, [currentSubmission])
    const data = useMemo(()=>get(assignment, "data",{}) || [], [assignment])
    const grade_type = assignment?.grade_type;
    const isCompleteInComplete = grade_type === "complete_incomplete"
    const max_point = assignment?.max_point && !isNaN(assignment?.max_point) ? Number.parseInt(assignment.max_point, 10) : 100
    const isPointSystem =  grade_type === "points"
    const [loading,setLoading] = useState(false)
    const timmerRef = useRef(null)
    const timeIntRef = useRef(0)
    const submitRef = useRef(null)
    const [timeInt, setTimeInt] = useState(0)
    const [, setTimmerRunning, clearTimmerRunning] = useTimmerRunning()
    const [finishlaterAlert, setFinishLaterAlert] = useState({ open: false, message: "" })
    const [trackingSessionEnded, setTrackingSessionEnded] = useState(false);
    const [values,setValues] = useState([])

    useEffect(()=>{
        if (currentSubmission?.assignment?.activity_type === 'graphic_organizer' && open) {
            AutoSubmissionFirebase(currentSubmission)
        }
    },[currentSubmission])

    const AutoSubmissionFirebase = (submission_value) => {
        if (!currentSubmission) return;
        const submissionWithUser = {
            ...currentSubmission,
            user: currentSubmission?.user || currentUser,
        };
        const submissionId = currentSubmission?.assignmentId + currentSubmission?.userId
        const data = {
            classId: get(currentClass, 'id', ''),
            userId: currentUser?.id,
            submissionData: submissionWithUser,
            submissionId,
            status: currentSubmission?.complete
        }
        createCollectionSubmission(data, submissionId)
    }

    const updateOnInterval = debounce((submission_value) => {
        if (submission_value.length > 0) {
            updateAnswers(submission_value, false, true)
        }
    }, 3000)

    function checkKey(e) {
        let graphicNoteOragniser = document.getElementsByClassName("graphicNote-oragnizer-navigation").length > 0;

        if(graphicNoteOragniser){
            return;
        }
        e = e || window.event;
        if (e.keyCode == '37') {
            if (backBtnRef.current && !backBtnRef.current.disabled) {
                backBtnRef.current.click()
            }

        }
        else if (e.keyCode == '39') {
            if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
                forwardBtnRef.current.click()
            }

        }

    }
    const setSubmitRef = (ref) => {
        submitRef.current = ref
    }
    useEffect(() => {
        if (setSubmitRef) {
            setSubmitRef(() => updateAnswers(values,true));
        }
    }, [setSubmitRef])



    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => (isMounted.current = false);
    }, []);

    useEffect(() => {
        return () => {
            if (!isMounted.current) {
                if (timeIntRef.current > 0) {
                    updateAnswers(values,true)
                }
            }
        }
    }, [timeIntRef.current, isMounted]);

    useEffect(() => {
        if (currentUser?.role != 'student' || !open) return;
        try {
            let actAct = assignment
            let Actdata = find(submissions, ['assignmentId', get(actAct, "activityId")])
            let _timmer = 0
            let _durration = 0;
            if (assignment && actAct) {
                _durration = actAct.timeDuration
                if (Actdata) {
                    if (!Actdata.complete) {
                        _timmer = Actdata.timmer
                    }
                    handleTimmer(_durration, _timmer)
                } else {
                    handleTimmer(_durration, _timmer)
                }
            }
        } catch (error) {
            console.log(error, "errr")
            Sentry.captureException(`214 Error in graphic assignment take ${error}`);
        }

    }, [assignment?.activityId,open])

    const handleTimmer = (timeDuration, timer) => {
        try {
            if (timeDuration && !isNaN(parseInt(timeDuration)) && parseInt(timeDuration) > 0) {
                let _timer = parseInt(timer) > 0 ? parseInt(timer) : parseInt(timeDuration) * 60
                if (timmerRef.current) { onFinish() };
                timeIntRef.current = _timer;
                setTimmerRunning()
                timmerRef.current = setInterval(() => {
                    if (timeIntRef.current > 0) {
                        timeIntRef.current = timeIntRef.current - 1
                        let timePrint = moment.utc(timeIntRef.current * 1000).format('HH:mm:ss');
                        setTimeInt(timePrint)
                    } else {
                        if (typeof submitRef.current == "function") {
                            submitRef.current(true, null, false, null, true)
                            submitRef.current = null
                            onFinish()
                        }
                    }
                }, 1000)
            }
        } catch (error) {
            console.log(error, "error in effect");
            Sentry.captureException(`215 Error in graphic assignment take ${error}`);
        }
        return () => {
            onFinish()
        }
    }
    const onFinish = () => {
        clearInterval(timmerRef.current)
        setTimeInt(0)
        timeIntRef.current = 0
        timmerRef.current = null
        clearTimmerRunning()
    }

    useEffect(() => {
        if (assignment) {
            let pg = assignment.assigned_on_page || assignment.data?.page;
            const index = findIndex(select_book_pages, (obj) => obj.pageId == pg)
            setCurrentPageIndex(index);
        }
    }, [select_book_pages, assignment])

    useEffect(() => {
        document.addEventListener('keydown', checkKey);
        return () => {
            document.removeEventListener("keydown", checkKey)
        }
    }, [])

    const closeAlert = () => {
        setAlertSakeBar({ open: false, message: "", severity: "success" });
    };

    const onPageChange = (direction) => {
        if (direction === "right" && currentPageIndex < select_book_pages.length - 1) {
            setCurrentPageIndex(currentPageIndex + 1);
        } else if (direction === "left" && currentPageIndex > 0) {
            setCurrentPageIndex(currentPageIndex - 1);
        }
    };
    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            console.log(error, "error")
            Sentry.captureException(`216 Error in graphic assignment take ${error}`);
        }
    }

    const invokSend = (data) => {
        if (socket) {
            try {
                if (socket.readyState == 3) {
                    reCreateSocket()
                    setTimeout(() => {
                        socket.send(JSON.stringify(data))
                    }, 2000)
                } else {
                    socket.send(JSON.stringify(data))
                }
            } catch (error) {
                console.log(error, "error")
                Sentry.captureException(`217 Error in graphic assignment take ${error}`);
            }
        }
    }
    const updateGradeToCanvas = async (_val) => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id) {
            await canvasSubmissionCreate()
            let assignmentId = assignment?.canvas_id ||  assignment?.data?.canvas_id
            if(assignmentId){
                await handleUpdateCanvasGrade(currentUser.canvas_id,{
                    "canvas_assignment_id": assignmentId,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":currentUser.canvas_id,
                    "grade": isCompleteInComplete?'complete': _val
                },currentUser.canvas_auth_id)
            }
        }
    }
    const canvasSubmissionCreate = async () => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id) {
            let assignmentId = assignment?.canvas_id ||  assignment?.data?.canvas_id
            if(assignmentId){
                await handleCreateCanvaSubmissions(currentUser.canvas_id,{
                    "canvas_assignment_id": assignmentId,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":currentUser.canvas_id,
                },currentUser.canvas_auth_id)
            }  
        }
    }
    const updateGradetoSchoology = async (_val, statusCode, manualGrading) => {
        if (currentClass && currentClass.sectionId && currentUser && currentUser.schoologyid&&assignment?.sAssignmentId) {
            await handleGradeToSchoology({
                sectionId: currentClass?.sectionId, schoologyid: currentUser.schoologyid, statusCode: statusCode, value: _val, studentSchoologyIds: [currentUser.schoologyid], sAssignmentId: assignment.sAssignmentId,
                manualGrading
            })
        }
    }
    const updateGradetoGoogleClassRoom = async (_val) => {
        if (currentClass && currentClass.googleId && currentUser && currentUser.googleId) {
            try {
                let assignmentId = assignment?.googleId || assignment?.data?.googleId
                if(assignmentId){
                    await handleUpdateGradeToGoogleClassRoom(currentUser.googleId, currentUser.googleId, currentClass.googleId, assignmentId, _val)
                }
            } catch (error) {
                console.log(error, "issue in update grade to classroom");
                Sentry.captureException(`218 Error in graphic assignment take ${error}`);
            }
        }
    }
    const handleRedirect = () =>{
        if(location.pathname.includes("ebook")){
            navigate(`/ebook?chapter=${data?.chapter}&page=${data?.page}`)
        }else{
            const parsedQuery = queryString.parse(location.search);
            delete parsedQuery.assignment_type;
            delete parsedQuery.activity_id;
            const updatedQueryString = queryString.stringify(parsedQuery);
            navigate(`${location.pathname}?${updatedQueryString}`);
        }
       
    }
    const sendNotiifcationFinal  = async () =>{
        if(!assignment) return;
        setOpen(false);
        handleRedirect()
        const chapter =  assignment.data.chapter;
        const page =  assignment.data.page;
        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(data, 'displayName', ''),
            senderId: get(currentUser, 'id', ''),
            receiversId: currentClassTeacher,
            modified: moment().toISOString(),
            data: {
                chapter: chapter,
                page: page,
                id: get(assignment, 'data.id', ''),
            },
            message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Submit this Assignment`,
            type: 'update_activity',
            userSeen: []
        }
        sendNotifications(notificationData);
    }
    const graphicResumeContext = useMemo(() => {
        if (currentUser?.role !== 'student' || !data?.id || trackingSessionEnded) return false;
        try {
            if (localStorage.getItem(`finishLater_${data.id}`) === 'true') return true;
        } catch {
        }
        const submissionCompleteTruthy =
            currentSubmission?.complete === true ||
            currentSubmission?.complete === 1 ||
            currentSubmission?.complete === '1' ||
            (typeof currentSubmission?.complete === 'string' &&
                String(currentSubmission.complete).toLowerCase() === 'true');
        if (currentSubmission?.id && !submissionCompleteTruthy) {
            const fl = currentSubmission.finishlater;
            if (fl != null && fl !== '') {
                const n = parseInt(fl, 10);
                if (!Number.isNaN(n) && n >= 0) return true;
            }
        }
        return false;
    }, [
        currentUser?.role,
        data?.id,
        trackingSessionEnded,
        currentSubmission?.id,
        currentSubmission?.complete,
        currentSubmission?.finishlater,
    ]);
    const handleActivityLogIdSynced = useCallback(
        (logId) => {
            if (!currentSubmission?.id || !logId) return;
            dispatch(
                SubmissionsActions.updateSubmissionSuccess({
                    ...currentSubmission,
                    log_id: logId,
                })
            );
        },
        [currentSubmission, dispatch]
    );
    const graphicScheduleFlushRef = useRef(null);
    const graphicFlushNowRef = useRef(null);
    const assignmentSessionReplay = useAssignmentSessionReplay({
        enabled: Boolean(open && currentUser?.role === 'student' && data?.id && currentClass?.id && currentUser?.id),
        assignmentId: data?.id,
        submissionId: currentSubmission?.id,
        activityLogId: currentSubmission?.log_id,
        serverMetaData: currentSubmission?.meta_data,
        submissionComplete: currentSubmission?.complete,
        completedSubmissionsCount: currentSubmission?.submissions,
        resumeContext: graphicResumeContext,
        sessionEnded: trackingSessionEnded,
        onRequestMetaFlush: () => graphicScheduleFlushRef.current?.(),
        onRequestImmediateFlush: () => graphicFlushNowRef.current?.(),
    });
    const assignmentTracking = useAssignmentSessionTracking({
        enabled: Boolean(open && currentUser?.role === 'student' && data?.id && currentClass?.id && currentUser?.id),
        assignmentId: data?.id,
        userId: currentUser?.id,
        classId: currentClass?.id,
        submissionId: currentSubmission?.id,
        serverMetaData: currentSubmission?.meta_data,
        resumeContext: graphicResumeContext,
        submissionComplete: currentSubmission?.complete,
        completedSubmissionsCount: currentSubmission?.submissions,
        sessionEnded: trackingSessionEnded,
        onLogIdSynced: handleActivityLogIdSynced,
        getExtraMeta: assignmentSessionReplay.getMetaForSync,
        onBeforeFlush: assignmentSessionReplay.onBeforeFlush,
    });
    graphicScheduleFlushRef.current = assignmentTracking.scheduleFlushToServer;
    graphicFlushNowRef.current = assignmentTracking.flushToServer;
    const updateAnswers = async (answers,complete=true, autoSave) => {
        if (!assignment) return;
        const chapter = assignment.data.chapter;
        let isLate = false
        if(complete&&timeout){
            clearTimeout(timeout)
        }
        if (assignment?.dueDate) {
            isLate = isBeforTime(assignment?.dueDate, servertime, timezone);
        }
        if (complete && onFinish && typeof onFinish == "function") {
            onFinish();
        }
        if (complete && currentUser?.role === 'student') {
            setTrackingSessionEnded(true);
        }
        if (!currentSubmission && !autoSave) {
            setLoading(true);
         await dispatch(handleCreateSubmission({
                assignmentId: data.id,
                assignmentType: data.typeId,
                classId: currentClass.id,
                orgId: currentUser?.orgId,
                userId: currentUser?.id,
                chapter: chapter,
                grade: isCompleteInComplete && complete ? '100' : null,
                face_grade: isCompleteInComplete && complete ? max_point : null,
                answers: answers,
                complete: complete,
                finishLater: null,
                submissions: complete?1:0,
                retakes: 0,
                retaking:complete ? false: true,
                graded: false,
                timmer: 0,
                isLate,
                manualGrading: true,
                assignment: assignment.data,
                meta_data: currentUser?.role === 'student' ? assignmentTracking.getMetaData() : undefined,
            }))
            setLoading(false);
            setOpen(false);
        }else if (!currentSubmission && autoSave) {
            setLoading(true);
             await dispatch(handleCreateSubmission({
                assignmentId: data.id,
                assignmentType: data.typeId,
                classId: currentClass.id,
                orgId: currentUser?.orgId,
                userId: currentUser?.id,
                chapter: chapter,
                grade: isCompleteInComplete && complete ? '100' : null,
                face_grade: isCompleteInComplete && complete ? max_point : null,
                answers: answers,
                complete: complete,
                finishLater: null,
                submissions: complete?1:0,
                retakes: 0,
                retaking: complete ? false: true,
                graded: false,
                timmer: 0,
                isLate,
                manualGrading: true,
                assignment: assignment.data,
                meta_data: currentUser?.role === 'student' ? assignmentTracking.getMetaData() : undefined,
            }))
            setLoading(false);
        } else if (autoSave) {
            setLoading(true);
            await dispatch(handleUpdateSubmission(
                currentSubmission?.id,
                {
                    answers: answers,
                    complete: false,
                    grade: isCompleteInComplete && complete? 100 : currentSubmission.grade,
                    face_grade: currentSubmission.face_grade,
                    submissions: currentSubmission.submissions ? (parseInt(currentSubmission.submissions, 10) || 0) : 0,
                    retaking: true,
                    graded: false,
                    feedback: '',
                    timmer: 0,
                    finishLater: null,
                    isLate,
                    manualGrading: true,
                    assignment: assignment.data,
                    meta_data: currentUser?.role === 'student' ? assignmentTracking.getMetaData() : undefined,
                }
            ));
        } else {
            setLoading(true);
            await dispatch(handleUpdateSubmission(
                currentSubmission.id,
                {
                    answers: answers,
                    complete: complete,
                    grade: isCompleteInComplete && complete? 100 : currentSubmission.grade,
                    face_grade: currentSubmission.face_grade,
                    submissions:complete? currentSubmission.submissions ? (parseInt(currentSubmission.submissions, 10) || 0) + 1 : 1:(parseInt(currentSubmission.submissions, 10) || 0),
                    retaking: complete ? false: true,
                    graded: false,
                    feedback: '',
                    timmer: 0,
                    finishLater: null,
                    manualGrading: true,
                    isLate,
                    assignment: assignment.data,
                    meta_data: currentUser?.role === 'student' ? assignmentTracking.getMetaData() : undefined,
                }
            ));
            setLoading(false)
            setOpen(false);
        }
        if (complete) {
            sendNotiifcationFinal()
            const grade_to_send = null;
            updateGradetoSchoology(grade_to_send, 0, true)
            updateGradeToCanvas(grade_to_send)
            updateGradetoGoogleClassRoom(grade_to_send)
        }
        setLoading(false)
    };

    const handleGraphicFinishLaterSave = useCallback(
        (vals) => {
            if (currentUser?.role === 'student') {
                setTrackingSessionEnded(true);
                assignmentTracking.recordFinishLater();
                assignmentSessionReplay.recordFinishLater();
            }
            updateAnswers(vals, false);
        },
        [currentUser?.role, assignmentTracking, assignmentSessionReplay, updateAnswers]
    );
    
    return (
        <SentryWrap>
        <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={finishlaterAlert.open}
                autoHideDuration={3000}
                onClose={() => { setFinishLaterAlert({ open: false, message: '' }) }}>
                <Alert onClose={() => { setFinishLaterAlert({ open: false, message: '' }) }} severity="error">
                    <strong>ALERT:</strong> {finishlaterAlert.message}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={alertSakeBar.open}
                autoHideDuration={3000}
                onClose={closeAlert}
            >
                <Alert
                    onClose={() => {
                        setAlertSakeBar({ open: false, message: "" });
                    }}
                    severity={alertSakeBar.severity}
                >
                    <strong>ALERT:</strong> {alertSakeBar.message}
                </Alert>
            </Snackbar>
            <Modal
                open={open}
                onClose={() => {
                    if (timeInt === 0) {
                        setOpen(false);
                        onFinish();
                    } else {
                        if (open && timeInt !== 0) {
                            showAlert("Timer-based assignments can't be 'finished later', it will be submitted automatically for you if you click on it.", "error");
                        } else {
                            onFinish();
                            setOpen(false); 
                        }
                    }
                }}   
               className={"lessonPlanPopUp lessonPlanPopUpTake 121"}>
                <div className="graphicOrganizerModallessonPlanTakeIner">
                 <div className='lessonPlanTakeIner'>
                <PlanWrapper>
                        <PlanContainer data-owe-assignment-session>
                        <CloseBtn
                            onClick={(e) => {
                                e.preventDefault();
                                if (timeInt === 0) {
                                    onFinish();
                                    setOpen(false);
                                } else {
                                    if (open && timeInt !== 0) {
                                        setFinishLaterAlert({ open: true, message: "Timer-based assignments can't be closed." });
                                    } else {
                                        onFinish();
                                        setOpen(false);
                                    }
                                }
                            }}
                        >
                            <Close
                                style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
                            />
                        </CloseBtn>
                        <ButtonContainer
                            ref={backBtnRef}
                            disabled={currentPageIndex === 0}
                            onClick={(e) => {
                                e.preventDefault();
                                onPageChange("left");
                            }}
                            left={8}
                        >
                            <ArrowBackIos style={{ fontSize: "40px" }} />
                        </ButtonContainer>
                        <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={currentPageIndex >= select_book_pages.length - 2}
                            onClick={() => {
                                onPageChange("right");
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: "40px" }} />
                        </ButtonContainer>
                        <Container>
                            <PrintWrapper>
                                <Row style={{ width: "100%", height: "100%" , maxWidth:"100%" , padding:0}}>
                                    <Col lg={12} md={24} xl={12} xs={24} >
                                        <Images
                                            src={activePageResource}
                                        />
                                    </Col>
                                    <Col lg={12} md={24} xl={12} xs={24} className='answerWindow 4545'>
                                        <AnswerWindow 
                                            src={currentPageResourse} input_position={input_position}  onSunmit={updateAnswers} onFinishLaterSave={handleGraphicFinishLaterSave} isLoading={loading} 
                                            submission={currentSubmission} 
                                            pastSubmission={pastSubmission} updateOnInterval={updateOnInterval} 
                                            timeInt={timeInt} setFinishLaterAlert={setFinishLaterAlert} timmer={timeIntRef.current} 
                                            setValues={setValues} values={values}
                                            isTime={parseInt(assignment.timeDuration) > 0}
                                            label_position={label_position}
                                        />
                                    </Col>
                                </Row>
                            </PrintWrapper>
                        </Container>
                    </PlanContainer>
                </PlanWrapper>
                </div>
                </div>
            </Modal>
        </SentryWrap>
    );
};

export default GraphicAssignmentTake;